import React from 'react';
import { Cctv, ShieldCheck } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import Intelbras from '../components/Intelbras';

const SCHEMA = {
  "@type": "Service",
  "serviceType": "Instalação de câmeras Intelbras e CFTV",
  "provider": { "@type": "LocalBusiness", "name": "Fernando Tech", "areaServed": "Ribeirão Preto e região" },
  "areaServed": { "@type": "City", "name": "Ribeirão Preto" },
  "description": "Venda e instalação de câmeras de segurança Intelbras, CFTV, alarmes e controle de acesso para empresas e residências em Ribeirão Preto e região.",
};

const FAQ = [
  { q: "A Fernando Tech instala câmeras Intelbras?", a: "Sim. Fazemos venda, projeto e instalação de câmeras Intelbras e sistemas de CFTV." },
  { q: "Consigo ver as câmeras pelo celular?", a: "Sim. Configuramos o acesso remoto para você visualizar as câmeras pelo celular ou computador." },
  { q: "Vocês atendem residências e empresas?", a: "Sim. Instalamos CFTV para residências, comércios e empresas em Ribeirão Preto e região." },
  { q: "Fazem manutenção de sistemas já instalados?", a: "Sim. Prestamos manutenção e ampliação de sistemas de câmeras existentes." },
  { q: "Como solicito um orçamento de câmeras?", a: "Você pode fazer o orçamento pela nossa página de orçamento Intelbras ou falar direto no WhatsApp." },
];

export default function IntelbrasPage() {
  return (
    <SubjectPageLayout
      path="/intelbras"
      breadcrumbName="Intelbras / CFTV"
      breadcrumbIcon={<Cctv className="w-3.5 h-3.5" />}
      seoTitle="Câmeras Intelbras e CFTV | Fernando Tech — Ribeirão Preto"
      seoDescription="Câmeras de segurança Intelbras, CFTV, alarmes e controle de acesso com venda e instalação profissional pela Fernando Tech em Ribeirão Preto e região. Solicite seu orçamento."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Segurança Eletrônica',
        badgeIcon: <ShieldCheck className="w-3.5 h-3.5" />,
        title: 'Câmeras Intelbras & CFTV',
        accent: 'proteção para empresas e residências',
        subtitle: 'Venda e instalação de câmeras de segurança Intelbras, CFTV, alarmes e controle de acesso — com projeto, instalação e suporte pela Fernando Tech.',
      }}
      cta={{
        heading: 'Quer proteger seu imóvel com câmeras?',
        text: 'Solicite um orçamento de CFTV Intelbras com a Fernando Tech. Projeto e instalação em Ribeirão Preto e região.',
        secondary: { label: 'Fazer orçamento Intelbras', to: '/orcamento-intelbras' },
      }}
    >
      <Intelbras />
    </SubjectPageLayout>
  );
}
